import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FlexDiv } from "../../assets/styles/style";
import {
  SPMainDiv,
  SPHeading,
  SPToogleIcon,
  SPParentDiv,
  StyledArrowForwardIosIcon,
} from "./Style";
import RALogo from "../../assets/images/SP_RA_Logo.svg";
import SearchBar from "./SearchBar";
import AllBookmarkPrediction from "./AllBookmark";
import SPTopicsCard from "./SPTopicsCard";
import { useAuth } from "../../authentication/Auth";
import Pagination from "./Pagination";
import { Base_URL } from "../../Client/apiURL";

const SidePannel = ({
  heading,
  testQuestions,
  totalTestQuestions = 0,
  setQuestionsData,
  questionID,
  setQuestionID,
  setTestQuestionTableId,
  testQuestionTableId,
  setSelectedAnswers,
  setTriggerReset,
  logo = null,
  handleSearchChange,
  onPageChange,
  currentPage,
  totalPages,
  setFilterBookmarked,
  setFilterPrediction,

  wantToSortDesc,
  setWantToSortDesc,
  highFrequency,
  setHighFrequency,

  isPracticed,
  setIsPracticed,
  setIsEasy,
  onToggle,
  updateLocalQuestionBookmark,
  setDataLoading,
  setAutoStartRecording,
  setCurrentQuestionIndex,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useAuth();
  const location = useLocation();

  const toggleSidePanel = () => {
    const newOpenState = !isOpen;
    setIsOpen(newOpenState);
    if (onToggle) {
      onToggle(newOpenState);
    }
  };

  useEffect(() => {
    const fetchData = async () => {

      if (setDataLoading) {
        setDataLoading(true);
      }

      const storedSelectedQuestion = JSON.parse(sessionStorage.getItem("selectedQuestion"));

      let activeQuestionId = questionID;
      let activeTestQuestionTableId = testQuestionTableId;

      if (storedSelectedQuestion && storedSelectedQuestion.currentPath === location.pathname && heading === "Multiple Choice, Single Answer") {
        activeQuestionId = storedSelectedQuestion.questionId;
        activeTestQuestionTableId = storedSelectedQuestion.testQuestionTableId;
      }

      try {
        const response = await fetch(
          `${Base_URL}/app/users/test-questions/get-question-with-options?question_id=${activeQuestionId}&test_question_id=${activeTestQuestionTableId}`,
          { credentials: "include" }
        );

        const data = await response.json();

        if (data.responseCode === 200 && data.response) {
          setQuestionsData(data);
          setSelectedAnswers(Array(data.response.AnswerNames.length).fill(""));
        } else if (data.responseCode && data.responseCode === 501) {
          logout();
          navigate("/login");
        }
      } catch (error) {
        console.error("Failed to fetch test questions:", error);
      } finally {
        if (setDataLoading) {
          setDataLoading(false);
        }
      }
    };

    if (questionID && testQuestionTableId) {
      fetchData();
    }
  }, [questionID, testQuestionTableId]);

  return (
    <>
      {/* {isLoading && <LoadingModal />} */}
      <SPParentDiv>
        <SPMainDiv isOpen={isOpen}>
          <SPToogleIcon onClick={toggleSidePanel}>
            <StyledArrowForwardIosIcon isOpen={isOpen} />
          </SPToogleIcon>
          <FlexDiv style={{ justifyContent: "space-between", gap: "15px" }}>
            <FlexDiv
              style={{
                justifyContent: "flex-start",
                gap: "1.25rem",
                alignItems: "center",
              }}
            >
              <img
                alt=""
                style={{ width: "45px", height: "45px" }}
                src={logo ? logo : RALogo}
              />
              <div>
                <SPHeading>{heading}</SPHeading>
              </div>
            </FlexDiv>
            <FlexDiv>
              <SearchBar handleSearchChange={handleSearchChange} />
            </FlexDiv>
          </FlexDiv>

          <FlexDiv>
            <AllBookmarkPrediction
              QuestionsCount={totalTestQuestions}
              onPredictionChange={setFilterPrediction}
              onFilterChange={setFilterBookmarked}
            />
          </FlexDiv>

          <SPTopicsCard
            questions={testQuestions}
            setQuestionID={setQuestionID}
            toggleSidePanel={toggleSidePanel}
            setTriggerReset={setTriggerReset}
            setTestQuestionTableId={setTestQuestionTableId}
            
            wantToSortDesc={wantToSortDesc}
            setWantToSortDesc={setWantToSortDesc}
            highFrequency={highFrequency}
            setHighFrequency={setHighFrequency}
            currentPage={currentPage}

            isPracticed={isPracticed}
            setIsPracticed={setIsPracticed}
            setIsEasy={setIsEasy}
            heading={heading}
            updateLocalQuestionBookmark={updateLocalQuestionBookmark}
            setAutoStartRecording={setAutoStartRecording}
            setCurrentQuestionIndexInParent={setCurrentQuestionIndex}
          />
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </SPMainDiv>
      </SPParentDiv>
    </>
  );
};

export default SidePannel;
